import type { DaemonTrigger, DiscoveredWorktreeListItem, WorktreeListItem } from './api';
import { getDiscoveredWorktreeDisplayName } from './api';

export type DaemonTriggerRunnerBoxInfo =
  | {
      kind: 'managed';
      worktreeId: string | null;
      alias: string | null;
      status: DaemonTrigger['worktreeStatus'];
    }
  | {
      kind: 'discovered';
      name: string | null;
      branch: string | null;
      status: DiscoveredWorktreeListItem['status'] | null;
    };

export const resolveDaemonTriggerRunnerBoxInfo = (
  trigger: DaemonTrigger | null,
  managedWorktrees: WorktreeListItem[],
  discoveredWorktrees: DiscoveredWorktreeListItem[],
): DaemonTriggerRunnerBoxInfo | null => {
  if (!trigger?.useWorktree) return null;

  if (trigger.discoveredWorktreeId) {
    const discovered = discoveredWorktrees.find((worktree) => worktree.id === trigger.discoveredWorktreeId);
    return {
      kind: 'discovered',
      name: discovered ? getDiscoveredWorktreeDisplayName(discovered) : null,
      branch: discovered?.branch ?? null,
      status: discovered?.status ?? null,
    };
  }

  const managed = trigger.worktreeId
    ? managedWorktrees.find((worktree) => worktree.worktreeId === trigger.worktreeId)
    : undefined;
  return {
    kind: 'managed',
    worktreeId: trigger.worktreeId,
    alias: managed?.alias ?? null,
    status: trigger.worktreeStatus,
  };
};
